import React from 'react';
import { MessageCircleIcon, YoutubeIcon, FacebookIcon, InstagramIcon, MusicIcon } from 'lucide-react';
const GOLD = '#C9A24B';
export function Footer() {
  const legalLinks = ['TERMENI ȘI CONDIȚII', 'POLITICA DE CONFIDENȚIALITATE', 'POLITICA DE COOKIES', 'ANPC'];
  const socials = [{
    label: 'WhatsApp',
    href: 'https://wa.me/40745180514',
    Icon: MessageCircleIcon
  }, {
    label: 'Youtube',
    href: '#',
    Icon: YoutubeIcon
  }, {
    label: 'Facebook',
    href: 'https://www.facebook.com/valer.dura',
    Icon: FacebookIcon
  }, {
    label: 'Instagram',
    href: 'https://www.instagram.com/valerdurabusinesscoach/',
    Icon: InstagramIcon
  }, {
    label: 'Tiktok',
    href: '#',
    Icon: MusicIcon
  }];
  return <footer className="w-full bg-[#09111F] pt-16 pb-8 border-t border-[rgba(255,255,255,0.08)]" data-id="element-42">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12" data-id="element-44">
          {/* CONTACT */}
          <div data-id="element-45">
            <p className="font-['Montserrat'] text-[15px] font-bold tracking-[0.06em] mb-6" style={{
            color: GOLD
          }} data-id="element-46">
              CONTACT
            </p>
            <div className="space-y-4 font-['Inter'] text-[15px] text-[rgba(255,255,255,0.85)] leading-relaxed" data-id="element-47">
              <p data-id="element-48">PERFORMANCE COACHING & TRAINING SRL, CUI: 43061087</p>
              <p data-id="element-49">Adresa: Satu Mare, strada Dragoș Vodă nr.10</p>
              <p data-id="element-50">Telefon: +40745180514</p>
              <p data-id="element-51">
                email:{' '}
                <a href="mailto:valerdura@yahoo.com" className="hover:text-white transition-colors" data-id="element-52">
                  valerdura@yahoo.com
                </a>
              </p>
            </div>
          </div>

          {/* LEGAL */}
          <div data-id="element-53">
            <p className="font-['Montserrat'] text-[15px] font-bold tracking-[0.06em] mb-6" style={{
            color: GOLD
          }} data-id="element-54">
              LEGAL
            </p>
            <div className="space-y-4" data-id="element-55">
              {legalLinks.map(link => <a key={link} href="#" className="block font-['Inter'] text-[15px] text-[rgba(255,255,255,0.85)] hover:text-white transition-colors" data-id="element-56">
                  {link}
                </a>)}
            </div>
          </div>

          {/* SOCIAL MEDIA */}
          <div data-id="element-57">
            <p className="font-['Montserrat'] text-[15px] font-bold tracking-[0.06em] mb-6" style={{
            color: GOLD
          }} data-id="element-58">
              SOCIAL MEDIA
            </p>
            <div className="space-y-4" data-id="element-59">
              {socials.map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 font-['Inter'] text-[15px] text-[rgba(255,255,255,0.85)] hover:text-white transition-colors" data-id="element-60">
                  <Icon className="w-5 h-5 flex-shrink-0" data-id="element-61" />
                  {label}
                </a>)}
            </div>
          </div>

          {/* ANPC + SOL Logos */}
          <div className="flex flex-col gap-4" data-id="element-62">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg p-2 hover:opacity-90 transition-opacity" data-id="element-63">
              <img src="https://cdn.magicpatterns.com/uploads/qEkMe7B8gpamVaXefnKexi/ANPC.webp" alt="ANPC - Soluționarea Alternativă a Litigiilor" className="w-full h-auto" data-id="element-64" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg p-2 hover:opacity-90 transition-opacity" data-id="element-65">
              <img src="https://cdn.magicpatterns.com/uploads/dUe8iPkBxBZ1Ryan5hWypX/Solutionarea_Online_a_Litigiilor.jpg" alt="Soluționarea Online a Litigiilor" className="w-full h-auto" data-id="element-66" />
            </a>
          </div>
        </div>

        {/* Divider + Copyright */}
        <div className="border-t border-[rgba(255,255,255,0.12)] pt-8 text-center" data-id="element-67">
          <p className="font-['Inter'] text-[14px] text-[rgba(255,255,255,0.7)]" data-id="element-68">
            © Copyright 2026.{' '}
            <span className="font-bold text-white" data-id="element-69">
              PERFORMANCE COACHING & TRAINING SRL
            </span>
            . Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>;
}